export default __webpack_public_path__ + "static/media/clown.ab32f2b3.png";